import React from 'react';
import { BarChart4, Cog, Network, Users } from 'lucide-react';

const features = [
  {
    title: 'Unified Digital Backbone',
    description: 'Connect enterprise applications through one integrated platform.',
    icon: Network,
    iconBackground: '#EFF6FF',
    accentColor: '#2563EB',
    borderColor: '#DBEAFE',
  },
  {
    title: 'Seamless Integration & Automation',
    description: 'Link Infor and third-party systems with intelligent workflows.',
    icon: Cog,
    iconBackground: '#ECFDF5',
    accentColor: '#059669',
    borderColor: '#D1FAE5',
  },
  {
    title: 'Data-Driven Intelligence',
    description: 'Use real-time analytics, AI-assisted decisions, and predictive insights.',
    icon: BarChart4,
    iconBackground: '#FEF3C7',
    accentColor: '#D97706',
    borderColor: '#FDE68A',
  },
  {
    title: 'Personalized User Experience',
    description: 'Equip teams with role-based dashboards and collaboration tools.',
    icon: Users,
    iconBackground: '#FEF2F2',
    accentColor: '#DC2626',
    borderColor: '#FECACA',
  },
];

const FeatureCard = ({
  icon: Icon,
  title,
  description,
  iconBackground,
  accentColor,
  borderColor,
}) => (
  <article
    className="group flex h-full min-w-0 flex-col rounded-2xl border bg-white p-6 transition duration-300 hover:-translate-y-1 hover:shadow-lg"
    style={{
      borderColor,
      boxShadow: '0 8px 24px rgba(15, 23, 42, 0.04)',
    }}
  >
    <div
      className="mb-5 flex h-11 w-11 items-center justify-center rounded-xl transition duration-300 group-hover:scale-105"
      style={{ backgroundColor: iconBackground, color: accentColor }}
    >
      <Icon aria-hidden="true" className="h-5 w-5" strokeWidth={1.8} />
    </div>

    <h3 className="mb-3 text-lg font-bold leading-snug" style={{ color: '#1A2634' }}>
      {title}
    </h3>

    <p className="mt-auto text-sm font-medium leading-6" style={{ color: '#334155', textAlign: 'left' }}>
      {description}
    </p>
  </article>
);

const InforOSFeatures = () => {
  return (
    <section
      aria-labelledby="infor-os-capabilities-title"
      className="px-4 py-14 sm:px-6 lg:px-8 lg:py-20"
      style={{ backgroundColor: '#FFFFFF' }}
    >
      <div className="mx-auto w-full max-w-7xl">
        <h2
          id="infor-os-capabilities-title"
          className="mb-10 text-2xl font-bold tracking-tight sm:text-3xl md:text-4xl"
          style={{ color: '#1A2634' }}
        >
          Infor OS Capabilities
        </h2>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((feature) => (
            <FeatureCard key={feature.title} {...feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default InforOSFeatures;
